module.exports = __webpack_public_path__ + "static/img/DaShu_Banner_spring.1b33cfc7.jpg";